export default "__VITE_ASSET__T5MT$qPQ__"